import React, { useContext } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import FormInput from 'components/Form/FormInput';
import DateInput from 'components/Form/DateInput';

import ResearchTaskReportContext from 'context/ResearchTaskReportContext';
import ResearchTaskReportBContext from 'context/ResearchTaskReportBContext';

const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
		padding: window.isMobile ? theme.spacing(0) : theme.spacing(0, 45, 0, 4),
		[theme.breakpoints.down('md')]: {
			paddingRight: theme.spacing(window.isMobile ? 0 : 4),
		},
	},
}));

const FinalInfo = () => {
	const { t } = useTranslation(null, { keyPrefix: 'Zadania badawcze - Raport B' });
	const classes = useStyles();
	const { mainInfo } = useContext(ResearchTaskReportContext);
	const { formData, onChange, errors, disabledInput, selectedLanguage } = useContext(ResearchTaskReportBContext);
	const data = formData[selectedLanguage];
	const handleChange = e => {
		const { name, value } = e.target;
		onChange(`pl.${name}`, value);
		onChange(`en.${name}`, value);
	};

	return (
		<Grid container className={classes.root}>
			<Grid item xs={12} sm={4}></Grid>
			<Grid item xs={12} sm={8}>
				<FormInput
					title={t('Osoba sporządzająca Raport')}
					value={`${mainInfo?.author?.firstname} ${mainInfo?.author?.surname}`}
					vertical
					disabled
					inputProps={{ 'aria-required': true }}
				/>
				<FormInput
					title={t('Główny Księgowy/Kwestor Podmiotu Lidera Zespołu Badawczego')}
					vertical
					name="quaestor"
					value={data.quaestor || ''}
					onChange={handleChange}
					error={errors?.quaestor}
					disabled={disabledInput || selectedLanguage === 'en'}
					inputProps={{ 'aria-required': true }}
				/>
				<FormInput
					title={t('Lider zespołu badawczego')}
					vertical
					name="leader"
					value={data.leader || ''}
					onChange={handleChange}
					error={errors?.leader}
					disabled={disabledInput || selectedLanguage === 'en'}
					inputProps={{ 'aria-required': true }}
				/>
				<FormInput
					title={t('Osoba posiadająca prawo reprezentacji Jednostki Naukowej')}
					vertical
					name="representative"
					value={data.representative || ''}
					onChange={handleChange}
					error={errors?.representative}
					disabled={disabledInput || selectedLanguage === 'en'}
					inputProps={{ 'aria-required': true }}
				/>
				<DateInput
					title={t('Data wypełnienia')}
					name="complete_date"
					value={data.complete_date || null}
					onChange={handleChange}
					error={errors?.complete_date}
					fullWidth
					vertical
					disabled={disabledInput || selectedLanguage === 'en'}
					inputProps={{ 'aria-required': true }}
				/>
			</Grid>
		</Grid>
	);
};

export default FinalInfo;